import { MessageError } from "src/types/errors/errors";

export const crmadsErrors: MessageError[] = [
    {
        key: 'No offers found or no longer available.',
        value: 'Oferta não está mais disponível.',
    },
    {
        key: 'Offer not found.',
        value: 'Oferta não está mais disponível.',
    },
    {
        key: 'Offer expired.',
        value: 'Oferta não está mais disponível.',
    },
    {
        key: 'Not enough points.',
        value: 'Você não tem pontos suficientes.',
    },
    {
        key: 'Failed purchasing offer.',
        value: 'Erro ao resgatar oferta. Tentar novamente mais tarde.',
    },
    {
        key: 'User not found.',
        value: 'Erro ao resgatar oferta. Tentar novamente mais tarde.',
    }
]